<template>
  <div v-html="qty"></div>
</template>

<script>
import { cbQtyText } from '@/utils';
export default {
  name: 'tdQty',
  props: ['row'],
  computed: {
    qty() {
      // Use grouped quantity if available, otherwise fall back to aggregated display
      if (this.row.qtyFormatted) {
        return this.row.qtyFormatted;
      }
      return cbQtyText(
        this.row.cases,
        this.row.bottles,
        this.row.skus,
        true,
        false,
        true
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdQty.vue